import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-prospect-menu',
  templateUrl: './prospect-menu.component.html',
  styleUrls: ['./prospect-menu.component.css']
})
export class ProspectMenuComponent implements OnInit {

  menuList:any;
  pageList:any;

  constructor() { }

  ngOnInit() {
    this.menuList=localStorage.getItem('menuList');
    this.menuList=JSON.parse(this.menuList);
    for(let i=0; i<this.menuList.length; i++){
      if(this.menuList[i].KHB_MenuName=='Prospect')
        this.pageList=this.menuList[i].KHB_PagesList;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/prospect/prospect-menu/prospect-menu.component.ts